import { render, staticRenderFns } from "./MembershipSettings.vue?vue&type=template&id=1562b226&scoped=true"
import script from "./MembershipSettings.vue?vue&type=script&lang=js"
export * from "./MembershipSettings.vue?vue&type=script&lang=js"
import style0 from "./MembershipSettings.vue?vue&type=style&index=0&id=1562b226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562b226",
  null
  
)

export default component.exports